import React, { useState, useCallback } from 'react';
import { InView } from 'react-intersection-observer';
import { useLang } from './localisation';

const withIntersectionObserver = Component => {
  return function ProjectMapInView(props) {
    const [scriptLoad, setScriptLoad] = useState(false);
    const currentLang = useLang();

    const getLang = () => {
      switch (currentLang) {
        case 'ae':
          return 'ar';
        case 'uk':
        case 'pl':
        case 'kz':
          return 'en';
        default:
          return currentLang;
      }
    };

    const onView = useCallback(inView => {
      if (inView && !window.google?.maps) {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${
          process.env.GATSBY_GOOGLE_MAPS_API_KEY
        }&language=${getLang()}`;
        script.async = true;
        script.type = 'text/javascript';

        script.onload = () => setScriptLoad(true);

        document.body.appendChild(script);

        return () => document.body.removeChild(script);
      }

      if (inView) {
        setScriptLoad(true);
      }
    }, []);

    return (
      <>
        {!scriptLoad && <InView onChange={onView} triggerOnce style={{ height: '100%' }}></InView>}
        {scriptLoad && <Component {...props} />}
      </>
    );
  };
};

export default withIntersectionObserver;
